import { Dialog, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import React from "react";
import { CancelIcon, SuccessBlueIcon } from "../../icon";
import ButtonComponent from "../shared/button/button.component";
import { useNavigate } from "react-router";
import { AppRoutes } from "../routes/route.path";


interface IProps {

    show: boolean;
    close: () => void;
    AcessingFeatures: { featureName: string, Desc?: string }[]

}

const UpgradePlanInfoComponent: React.FC<IProps> = (Props: IProps) => {

    const navigate = useNavigate()

    return (

        <Dialog
            fullWidth
            onClose={() => Props.close()}
            aria-labelledby="responsive-dialog-title"
            open={Props.show}
            classes={{ paper: "br-2 w-p-45 min-w-50 dialogue-shadow bg-color-secondary" }}
            BackdropProps={{ style: { backgroundColor: "transparent" } }}
        >
            <DialogTitle id="alert-dialog-title" className="dialog-header">
                <div className='d-flex justify-center align-center w-p-100'>
                    <div className="w-p-96 d-flex justify-center">Upgrade Subscription</div>
                    <Tooltip title='Close' placement='bottom'>
                        <CancelIcon className={"c-pointer ml-auto"} onClick={() => Props.close()} />
                    </Tooltip>
                </div>
            </DialogTitle>
            <DialogContent>
                {Props.AcessingFeatures.map((x) => {
                    return <>
                        < div className="d-flex align-center pt-2 pb-1 ml-3" >
                            <SuccessBlueIcon />
                            <div className="ml-2 color-upgrade-plan-dialog-content h4-semibold">
                                {x.featureName}
                            </div>
                        </div>
                        {x.Desc && <div className="color-upgrade-plan-dialog-content live-chat-subheader ml-8">
                            {x.Desc}
                        </div>}
                    </>
                })}
                <div className="d-flex align-center justify-center mt-4">
                    <ButtonComponent ButtonLabel={"Cancel"} Variant={"secondary-btn"} OnClick={Props.close} ClassName="mr-2" />
                    <ButtonComponent ButtonLabel={"Upgrade"} Variant={"primary-btn"} OnClick={() => navigate(AppRoutes.CHANNELS_PLANS)} />
                </div>
            </DialogContent>
        </Dialog >

    )
}

export default UpgradePlanInfoComponent;